module.exports = __webpack_public_path__ + "static/react.007cf733.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/react.svg
// module id = 745
// module chunks = 263791100135453